"use strict";

var widgetsServiceRequestControllers = angular.module("controllers.service.widgets.create", ['ngSanitize']);

widgetsServiceRequestControllers.controller("wFaultTypeCtrl", ['$scope', 'serviceRequestCreation', 'lookUpService', 'numberToHoursMinutesFilter', function ($scope, serviceRequestCreation, lookUpService, numberToHoursMinutesFilter) {

    $scope.eventTypes = [];

    $scope.selectEvent = function (index) {
        serviceRequestCreation.setEvent($scope.eventTypes[index]);
        $scope.$parent.next();
    };

    lookUpService.list("eventType").then(function (resource) {
        resource.$get("eventTypeList").then(function (eventTypes) {
            $scope.eventTypes = eventTypes;
        });
    });

    $scope.$on("$destroy")
}]);

widgetsServiceRequestControllers.controller("wAffectedMachineCtrl", ['$scope', 'serviceRequestCreation', 'stationService', 'machineService', 'machineCategoryService', 'serviceRequestService', '$location', '$translate', 'localStorageService', 'filterFilter', 'authenticationService', 'appSettings', 'storageKeys',
    function ($scope, serviceRequestCreation, stationService, machineService, machineCategoryService, serviceRequestService, $location, $translate, localStorageService, filterFilter, authenticationService, appSettings, storageKeys) {
        $scope.costApproverRole=appSettings.costApproverRole;
        $scope.storeApproverRole=appSettings.storeApproverRole;
        $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
        $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

        $scope.widgetInfo = {
            step: 0,
            goBack: false,
            title: $translate.instant('label.controller.services.createWidgetsController.WhichArea')
        };

        $scope.stations = [];
        $scope.categories = [];
        $scope.machines = [];

        $scope.selectedMachine = {};

        stationService.find().then(function (resource) {
            resource.$get("stationList").then(function (stations) {
                $scope.stations = stations;
            });
        });

        $scope.selectStation = function (index) {
            serviceRequestCreation.setStation($scope.stations[index]);

            machineCategoryService.findByStation($scope.stations[index].id).then(function (resource) {
                resource.$get("machineCategoryList").then(function (categories) {
                    $scope.categories = categories;
                });
            });

            $scope.widgetInfo.step++;
        };

        $scope.selectCategory = function (index) {
            serviceRequestCreation.setCategory($scope.categories[index]);

            var stationId = serviceRequestCreation.get().station.id;

            machineService.findByStationAndCategory(stationId, $scope.categories[index].id).then(function (resource) {
                resource.$get("machineList").then(function (machines) {
                    $scope.machines = machines;
                });
            });

            $scope.widgetInfo.step++;
        };

        $scope.selectMachine = function (index) {
            $scope.selectedMachine = $scope.machines[index];
            $scope.selectedMachine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                $scope.selectedMachine.partsWithExtendedWarranty = partsWithExtendedWarranty.components;
                $scope.selectedMachine.isUnderWarranty = partsWithExtendedWarranty.underWarranty;
                $scope.selectedMachine.isUnderComponentWarranty = partsWithExtendedWarranty.underComponentWarranty;

            });
            serviceRequestCreation.setMachine($scope.selectedMachine);
            serviceRequestService.checkOpenServiceRequest($scope.selectedMachine.id, serviceRequestCreation.get().event.id).then(
                function (resource) {
                    $scope.widgetInfo.step = -1;
                },
                function (status) {
                    if (status.status === 404) { // NOT FOUND
                        $scope.widgetInfo.step++;
                    }
                }
            );
        };

        $scope.openExtendedWarrantyModal = function () {
            $('#openExtendedWarrantyLoader').show();
            $scope.selectedMachine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                $scope.partsWithExtendedWarranty = partsWithExtendedWarranty.components;
                $('#extendedWarrantyModal').modal("show");
                $('#openExtendedWarrantyLoader').hide();
            });

        };

        $scope.no = function () {
            $location.path('/');
        };

        $scope.yes = function () {
            $scope.$parent.next();
        };

        $scope.goBack = function () {
            $scope.widgetInfo.step--;
        };

        $scope.$watch('widgetInfo.step', function (newValue, oldValue) {
            switch (newValue) {
                case 0:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.WhichArea');
                    $scope.widgetInfo.goBack = false;
                    break;
                case 1:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.ItemCategory');
                    $scope.widgetInfo.goBack = true;
                    break;
                case 2:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.ItemEquipment');
                    $scope.widgetInfo.goBack = true;
                    break;
                case 3:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.WarrantyInfo');
                    $scope.widgetInfo.goBack = true;
                    break;
                case -1:
                    $scope.widgetInfo.title = $translate.instant('label.Warning');
                    $scope.widgetInfo.goBack = false;
                    break;
            }
        });

        $scope.hasRole = function (role) {
            return authenticationService.userHasRole(role);
        };

    }]);

widgetsServiceRequestControllers.controller("wIssueDescriptionCtrl", ['$scope', '$translate', '$sce', 'serviceRequestCreation', 'commonFaultService', 'storeService', 'serviceRequestService', '$location',
    function ($scope, $translate, $sce, serviceRequestCreation, commonFaultService, storeService, serviceRequestService, $location) {

        $scope.widgetInfo = {
            step: 0,
            goBack: false,
            title: $translate.instant('label.controller.services.createWidgetsController.YourIssue')
        };

        $scope.form = {};
        $scope.form.issueDescription = "";

        if (serviceRequestCreation.get().issueDescription)
            $scope.form.issueDescription = serviceRequestCreation.get().issueDescription;

        $scope.commonFaults = [];
        $scope.selectedCommonFault = {};

        $scope.selectCommonFault = function (index) {
            $scope.commonFaults[index].$get("self").then(function (commonFault) {
                $scope.selectedCommonFault = commonFault;
                serviceRequestCreation.setCommonFault(commonFault);
                $scope.widgetInfo.step++;
            });
        };

        $scope.selectNoCommonFault = function () {
            $scope.widgetInfo.step = 2;
        };

        commonFaultService.listByMachineId(serviceRequestCreation.get().machine.id).then(function (resource) {
                resource.$get("commonFaultList").then(function (commonFaults) {
                    if (commonFaults && commonFaults.length > 0) {
                        $scope.commonFaults = commonFaults;
                    } else {
                        $scope.widgetInfo.step = 2;
                    }
                });
            },
            function (status) {
                if (status.status === 404) $scope.widgetInfo.step = 2;
            });

        $scope.yes = function () {
            serviceRequestCreation.setCancelledByUser(true);
            var serviceRequestToSave = serviceRequestCreation.getServiceRequestToSave(storeService.getStore());
            serviceRequestService.create(serviceRequestToSave).then(
                function (response) {
                    $scope.saveResult = response;
                    $scope.success = 1;
                    $scope.$parent.finish();
                    $location.path("/");
                },

                function (status) {
                    if (status.status !== 200) {
                        // Something went wrong
                        $scope.success = -1;
                    }
                }
            );
        };

        $scope.no = function () {
            $scope.widgetInfo.step++;
        };

        $scope.goBack = function () {
            $scope.widgetInfo.step--;
        };

        $scope.$watch('form.issueDescription', function (newValue, oldValue) {
            serviceRequestCreation.setIssueDescription(newValue);
        });

        $scope.$watch('widgetInfo.step', function (newValue, oldValue) {
            switch (newValue) {
                case 0:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.ChooseFaultDescription');
                    $scope.widgetInfo.goBack = false;
                    break;
                case 1:
                    $scope.widgetInfo.title = $scope.selectedCommonFault.displayName;
                    $scope.widgetInfo.goBack = true;
                    break;
                case 2:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.AddIssueDescription');
                    $scope.widgetInfo.goBack = ($scope.selectedCommonFault === null);
                    break;
            }
        });

        $scope.next = function () {
            if ($scope.form.issueDescription == "") {
                $scope.error = true;
                $scope.errorMessage = $translate.instant('label.views.service-creation.issueDescription.Add');
                return;
            } else if ($scope.form.issueDescription.length > 4000) {
                $scope.error = true;
                $scope.errorMessage = $translate.instant('label.views.service-creation.issueDescription.maxLength');
                return;
            }
            $scope.$parent.next();
        }
    }]);

widgetsServiceRequestControllers.controller("wLinkServiceCtrl", ['$scope', 'serviceRequestCreation', 'serviceRequestService', 'localStorageService', 'storageKeys', function ($scope, serviceRequestCreation, serviceRequestService, localStorageService, storageKeys) {
    $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
    $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

    $scope.linkServiceRequests = [];

    serviceRequestService.findByMachine(serviceRequestCreation.get().machine.id).then(
        function (resource) {
            resource.$get("serviceRequestList").then(function (linkServiceRequests) {
                $scope.linkServiceRequests = linkServiceRequests;
            });
        },
        function (status) {
            if (status.status === 404){} $scope.$parent.next(true);
        }
    );

    $scope.linkServiceRequest = function (index) {
        serviceRequestCreation.setLinkedServiceRequest($scope.linkServiceRequests[index]);
        $scope.$parent.next();
    }
}]);

widgetsServiceRequestControllers.controller("wServiceAgentCtrl", ['$scope', 'providerService', 'serviceRequestCreation', 'wikiService', '$modal', 'serviceProviderResponseTimeService', '$sce', function ($scope, providerService, serviceRequestCreation, wikiService, $modal, serviceProviderResponseTimeService, $sce) {

    var defaultAgents = [];

    $scope.step = 0;
    $scope.serviceAgents = [];
    $scope.serviceAgentsNotFound = false;
    $scope.hoursConditions = [];
    $scope.showNextButton = false;

    $scope.dataLoaded = false;

    $scope.defaultCosts = [];
    $scope.availability = null;

    $scope.responseTimes = [];

    $scope.serviceAgentsWithNoInsurance = [];

    $scope.saveList = function () {
        serviceRequestCreation.setProviderList($scope.serviceAgents);

        var needToConfirm = true;
        $scope.hoursConditions = [];
        var providerConditions = [];
        var loadedConditions = 0;

        for (var i = 0; i < $scope.serviceAgents.length; i++) {
            if ($scope.serviceAgents[i].confirmExtendedService) {
                providerConditions.push($scope.serviceAgents[i]);
                break;
            }
        }

        if (providerConditions.length > 0) {
            for (var i = 0; i < providerConditions.length; i++) {
                wikiService.getOutOfHoursConditions(providerConditions[i].id).then(function (wikiResponse) {
                    wikiResponse.htmlContent = $sce.trustAsHtml(wikiResponse.content);
                    $scope.hoursConditions.push(wikiResponse);
                    loadedConditions++;
                    if (loadedConditions >= providerConditions.length) $scope.step++;
                });
            }
        } else {
            $scope.$parent.next();
        }
    };

    $scope.rejectConditions = function () {
        serviceRequestCreation.setExtendedServiceConfirmed(false);
        $scope.$parent.next();
    };

    $scope.acceptConditions = function () {
        serviceRequestCreation.setExtendedServiceConfirmed(true);
        $scope.$parent.next();
    };

    $scope.resetList = function () {
        $scope.serviceAgents = defaultAgents.slice();
    };

    $scope.goBack = function () {
        $scope.step--;
    };

    providerService.findByMachine(serviceRequestCreation.get().event.eventTypeGroupId, serviceRequestCreation.get().machine.id).then(
        function (resource) {
            resource.$get("serviceProviderList").then(function (serviceProviders) {
                for (var i = 0; i < serviceProviders.length;) {
                    if (!serviceProviders[i].insured) {
                        $scope.serviceAgentsWithNoInsurance.push(serviceProviders[i]);
                        serviceProviders.splice(i, 1);
                    } else {
                        i++;
                    }
                }
                $scope.serviceAgents = serviceProviders;
                defaultAgents = $scope.serviceAgents.slice();
                angular.forEach($scope.serviceAgents, function (serviceAgent) {
                    serviceAgent.hasVariance = serviceAgent.hasResponseTimeVariance;
                });
                $scope.showNextButton = ($scope.serviceAgents.length === 0) ? false : true;
                $scope.dataLoaded = true;
            });
        },
        function (status) {
            if (status.status === 404) {
                $scope.serviceAgentsNotFound = true;
                $scope.dataLoaded = true;
            }
        }
    );

    $scope.removeProvider = function (index) {
        if ($scope.serviceAgents.length > 1) $scope.serviceAgents.splice(index, 1);
    };

    $scope.removeProviderUsingEvent = function (event, name) {
        if (typeof name !== 'undefined') {
            for (var i = 0; i < $scope.serviceAgents.length; i++) {
                if ($scope.serviceAgents[i].name === name) {
                    $scope.removeProvider(i);
                }
            }
        }
    };

    $scope.showInformationUsingEvent = function (event, name) {
        if (typeof name !== 'undefined') {
            for (var i = 0; i < $scope.serviceAgents.length; i++) {
                if ($scope.serviceAgents[i].name === name) {
                    $scope.viewServiceProviderInfo(i);
                }
            }
        }
    };

    $scope.viewServiceProviderInfo = function (index) {
        $scope.defaultCosts = [];
        $scope.availability = null;
        providerService.getDefaultCosts($scope.serviceAgents[index].id).then(function (resource) {
            resource.$get("defaultCostList").then(function (defaultCosts) {
                $scope.defaultCosts = defaultCosts;
            });
        });

        providerService.availability($scope.serviceAgents[index].id).then(function (resource) {
            $scope.availability = resource;
        });

        $modal.open({
            templateUrl: "js/directives/templates/serviceAgentInfo.tpl.html",
            controller: ServiceAgentModalCtrl,
            resolve: {
                request: function () {
                    return $scope;
                }
            }
        });

        $scope.serviceAgents[index].$get("responseTimes").then(function (result) {
            $scope.responseTimes = result;
        })
    };

    $scope.onFilter = function (evt) {
        if (typeof evt !== 'undefined' && typeof evt.srcElement !== 'undefined') {
            if (evt.srcElement.id == "removeProvider") {
                $scope.removeProvider(evt.oldIndex);
            } else if (evt.srcElement.id == "viewServiceProviderInfo") {
                $scope.viewServiceProviderInfo(evt.oldIndex);
            }
        }
    }
}]);

widgetsServiceRequestControllers.controller("wNotificationCtrl", ['$scope', 'serviceRequestCreation', 'storeService', function ($scope, serviceRequestCreation, storeService) {

    var store = storeService.getStore();
    $scope.option = -1;
    $scope.phoneNumber = store.phoneNumber;
    $scope.smsNumber="";
    $scope.showError = false;

    $scope.setOption = function (option) {
        $scope.option = ($scope.option === option) ? $scope.option = -1 : option;
    };

    var regex = new RegExp("^[0-9]{1,15}$");

    $scope.saveOption = function (type, number) {
            if(!number.match(regex) || number.trim() === "") {
                $scope.showError = true;
                return;
            }else{
                serviceRequestCreation.setNotification(type, number);
                $scope.$parent.next();
            }
    };
}]);

widgetsServiceRequestControllers.controller("wReviewCtrl", ['$scope', '$location', 'serviceRequestCreation', 'storeService', 'serviceRequestService', 'localStorageService', 'filterFilter', 'authenticationService', 'componentService', 'appSettings', 'storageKeys',
    function ($scope, $location, serviceRequestCreation, storeService, serviceRequestService, localStorageService, filterFilter, authenticationService, componentService, appSettings, storageKeys) {

        $scope.storeManagerRole=appSettings.storeManagerRole;
        $scope.storeApproverRole=appSettings.storeApproverRole;
        // -1: error, 0: not init, 1: success
        $scope.success;
        $scope.saveResult = {};
        $scope.review = serviceRequestCreation.get();

        $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
        $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

        $scope.save = function () {
            // Lately we've been experiencing an odd issue where the user somehow
            // managed to spam click the button and create duplicate SR.
            // We believe it could be due to a wrong misbehaviour of ng-disabled
            // on some old versions of internet explorer. Consequently, the button
            // will be disabled in the old fashion way for safety
            document.getElementById("createBtn").disabled = true;
            $scope.success = 0;
            var serviceRequestToSave = serviceRequestCreation.getServiceRequestToSave(storeService.getStore());
            serviceRequestService.create(serviceRequestToSave).then(
                function (response) {
                    $scope.saveResult = response;
                    $scope.success = 1;
                    $scope.$parent.finish();
                },
                function (response) {
                    if (response.status !== 200) {
                        $scope.saveResult = response.data.message;
                        // Something went wrong
                        $scope.success = -1;
                        document.getElementById("createBtn").disabled = false;
                    }
                }
            );
        };

        $scope.hasRole = function (role) {
            return authenticationService.userHasRole(role);
        };

        $scope.goBack = function () {
            $location.path("/");
        };

        $scope.openExtendedWarrantyModal = function () {
            $('#openExtendedWarrantyLoader').show();
            $scope.review.machine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                $scope.partsWithExtendedWarranty = partsWithExtendedWarranty.components;
                $('#extendedWarrantyModal').modal("show");
                $('#openExtendedWarrantyLoader').hide();
            });
        };
    }]);

